import { useState, useEffect } from 'react';
import { fetchLatestScores } from '@/services/scoreService';

const Timestamp = () => {
  const [lastUpdated, setLastUpdated] = useState<string>('');

  useEffect(() => {
    const loadTimestamp = async () => {
      try {
        const data = await fetchLatestScores();
        const date = new Date(data.last_updated);
        const formatted = date.toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
        const time = date.toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'UTC',
        });
        setLastUpdated(`${formatted}, ${time} UTC`);
      } catch (error) {
        console.error('Failed to load timestamp:', error);
        setLastUpdated('Unable to load timestamp');
      }
    };

    loadTimestamp();
  }, []);

  return (
    <div className="fixed top-2 right-6 z-[1000]">
      <p className="text-text-tertiary text-[10px]">
        Last updated: {lastUpdated || 'Loading...'}
      </p>
    </div>
  );
};

export default Timestamp;
